<template>
  <div class="home">
    <div class="company-container">
      <div class="form" v-show="type===1">
        <img class="form-img" src="../assets/images/signin.png" alt />
        <van-field
          readonly
          right-icon="arrow-down"
          name="picker"
          :value="warehouse.text"
          label="仓库："
          placeholder="请选择要去的仓库"
          @click="openPicker(1)"
        />
        <van-field
          readonly
          right-icon="arrow-down"
          name="picker"
          :value="company.text"
          label="公司："
          placeholder="请选择所派遣的劳务公司"
          @click="openPicker(2)"
        />
        <van-field
          readonly
          right-icon="arrow-down"
          name="picker"
          :value="worktType.text"
          label="工种："
          placeholder="请选择所属工种"
          @click="openPicker(3)"
        />
        <van-field v-model="username" label="姓名：" placeholder="请输入你的姓名" />
        <van-button class="sign-in" type="info" @click="signIn">签到</van-button>
      </div>
      <div class="success" v-show="type===2">
        <img class="img-success" src="../assets/images/success.png" alt />
        <p class="success-text">{{username}}，恭喜“{{workText}}”签到成功！</p>
        <div class="date-content">
          <p class="date">{{date}}</p>
          <p class="time">{{time}}</p>
        </div>
      </div>
    </div>
    <div class="bottom" v-show="type===1">
      <van-divider>签到说明</van-divider>
      <p class="explain">
        <span class="circle"></span>每日记得上下班打卡
      </p>
      <p class="explain">
        <span class="circle"></span>全部填写后并点击“签到”按钮完成打卡签到
      </p>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :title="pickerTitle"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import Model from "models/model";
const model = new Model();
import Vue from "vue";
import { Field, Button, Divider, Toast, Popup, Picker } from "vant";
Vue.use(Field)
  .use(Button)
  .use(Divider)
  .use(Toast)
  .use(Popup)
  .use(Picker);
export default {
  data() {
    return {
      type: 1,
      signNumber: "",
      timeStamp: "",
      workText: "",
      warehouse: {
        id: "",
        text: ""
      },
      company: {
        id: "",
        text: ""
      },
      worktType: {
        id: "",
        text: ""
      },
      username: "",
      date: "",
      time: "",
      warehouseList: [], //仓库列表
      companyList: [], //仓库列表
      worktTypeList: [
        {
          id: 1,
          text: "周期工"
        },
        {
          id: 2,
          text: "临时工"
        }
      ], //工种
      showPicker: false,
      pickerType: "",
      pickerTitle: "",
      columns: []
    };
  },
  created() {
    if (this.$route.query) {
      this.signNumber = this.$route.query.signNumber;
      this.timeStamp = this.$route.query.timeStamp;
    }
    this.getWarehouseList();
  },
  methods: {
    //获取仓库数据
    getWarehouseList() {
      model.warehouseList().then(res => {
        if (res.success) {
          let warehouseList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.text = value.name;
            warehouseList.push(obj);
          });
          this.warehouseList = warehouseList;
        }
      });
    },
    //获取劳务公司
    getCompanyList() {
      let warehouseId = this.warehouse.id;
      model.laborList(warehouseId).then(res => {
        if (res.success) {
          let companyList = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.text = value.name;
            companyList.push(obj);
          });
          this.companyList = companyList;
        }
      });
    },
    //打开选择器
    openPicker(type) {
      this.pickerType = type;
      if (type === 1) {
        this.pickerTitle = "仓库";
        this.columns = this.warehouseList;
        this.showPicker = true;
      } else if (type === 2) {
        if (this.warehouse.id) {
          this.pickerTitle = "劳务公司";
          this.columns = this.companyList;
          if (this.columns.length > 0) {
            this.showPicker = true;
          } else {
            Toast("该仓库下无劳务公司");
          }
        } else {
          Toast("请先选择仓库");
        }
      } else if (type === 3) {
        this.pickerTitle = "工种";
        this.columns = this.worktTypeList;
        this.showPicker = true;
      }
    },
    //确定
    onConfirm(value) {
      if (this.pickerType === 1) {
        if (value.id !== this.warehouse.id) {
          this.company.id = "";
          this.company.text = "";
        }
        this.warehouse = value;
        this.getCompanyList();
      } else if (this.pickerType === 2) {
        this.company = value;
      } else {
        this.worktType = value;
      }
      this.showPicker = false;
    },
    //签到
    signIn() {
      if (
        this.username === "" ||
        !this.warehouse.id ||
        !this.company.id ||
        !this.worktType.id
      ) {
        Toast("请输入完整信息");
      } else {
        let warehouseId = this.warehouse.id;
        let laborId = this.company.id;
        let type = this.worktType.id;
        let name = this.username;
        let signNumber = this.signNumber;
        let timeStamp = this.timeStamp;
        let data = {
          warehouseId,
          name,
          type,
          laborId,
          timeStamp,
          signNumber
        };
        Toast.loading({
          message: "签到中...",
          forbidClick: true,
          duration: 0
        });
        model.sign(data).then(res => {
          if (res.success) {
            this.workText = res.result.timeStatus;
            this.date = this.getDate(res.result.date);
            this.time = this.getTime(res.result.date);
            this.type = 2;
            Toast.clear();
          } else {
            Toast(res.message);
          }
        });
      }
    },
    getDate(time) {
      let date = new Date(time);
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let detailDate = date.getDate();
      detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
      return `${month}月${detailDate}日`;
    },
    getTime(time) {
      let date = new Date(time);
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      return `${hour}:${minute}:${second}`;
    }
  }
};
</script>
<style lang='less' scoped>
.home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .company-container {
    flex: 1;
    background: url(../assets/images/home.png) center top no-repeat;
    background-size: 420px;
    padding: 146px 12px 30px 12px;
    display: flex;
    flex-direction: column;
    .form {
      padding: 40px 25px 32px 25px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 10px 0px rgba(0, 104, 255, 0.1);
      border-radius: 8px;
      position: relative;
      .form-img {
        position: absolute;
        left: 50%;
        top: -35px;
        width: 106px;
        height: 54px;
        margin-left: -53px;
      }
      /deep/ .van-field {
        padding: 0;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .van-field__label {
          max-width: 50px;
          min-width: 50px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          font-size: 15px;
          margin-right: 0px;
        }
        .van-field__body {
          height: 36px;
          border: 1px solid rgba(189, 203, 230, 1);
          border-radius: 2px;
          padding-left: 10px;
          padding-right: 10px;
        }
      }
      .van-cell::after {
        border-bottom: 0;
      }
      .sign-in {
        width: 100%;
        height: 44px;
        background: rgba(0, 104, 255, 1);
        box-shadow: 0px 3px 9px 0px rgba(0, 104, 255, 0.36);
        border-radius: 4px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .success {
      padding: 40px 25px 32px 25px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 10px 0px rgba(0, 104, 255, 0.1);
      border-radius: 8px;
      position: relative;
      .img-success {
        position: absolute;
        left: 50%;
        top: -43px;
        width: 85px;
        height: 88px;
        margin-left: -42px;
      }
      .success-text {
        font-size: 18px;
        font-weight: bold;
        padding-top: 15px;
        padding-bottom: 25px;
        text-align: center;
        border-bottom: 1px solid #e5e5e5;
      }
      .date-content {
        padding-top: 29px;
        font-size: 45px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 60px;
        text-align: center;
        .time {
          font-size: 50px;
          font-weight: 900;
        }
      }
    }
  }
  .bottom {
    padding: 0px 30px 0 30px;
    box-sizing: border-box;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    .van-divider {
      margin: 10px 0;
    }
    .explain {
      margin-bottom: 12px;
      .circle {
        width: 2.5px;
        height: 3px;
        display: inline-block;
        background: rgba(153, 153, 153, 1);
        border-radius: 50%;
        margin-bottom: 2px;
        margin-right: 5px;
      }
    }
  }
}
</style>